import { AlmanacProvider } from '../providers/almanacProvider.js';
import { mapParamsToObject } from '../../utilities/mapParamsToObject';


export const GET_ALMANAC_BY_LATLON = 'GET_ALMANAC_BY_LATLON';
export const GET_ALMANAC_BY_LATLON_PENDING = 'GET_ALMANAC_BY_LATLON_PENDING';
export const GET_ALMANAC_BY_LATLON_FULFILLED = 'GET_ALMANAC_BY_LATLON_FULFILLED';
export const GET_ALMANAC_BY_LATLON_REJECTED = 'GET_ALMANAC_BY_LATLON_REJECTED';


export function getAlmanacByLatLon(...params) {
    let paramsObject = {
        latitude: undefined,
        longitude: undefined,
        baseUrl: undefined,
        authId: undefined,
        secret: undefined,
        stdParameters: undefined
    };
    paramsObject = mapParamsToObject(params, paramsObject);
    
    return {
        type: GET_ALMANAC_BY_LATLON,
        payload: getAlmanac(paramsObject)
    };
}

async function getAlmanac({ latitude, longitude, baseUrl, authId, secret, stdParameters }) {
   
    const op = new AlmanacProvider(baseUrl, authId, secret);
    return await op.getAlmanac(latitude, longitude, stdParameters);
}
